// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__34fdH","footer":"ReportModalFilter_footer__31sqx"};